module.exports = __webpack_public_path__ + "static/img/Collection.771e416f.svg";